import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={clsxm('bg-neutral animate-pulse rounded-md', className)}
      {...props}
    />
  );
}
